const initialState = {
	vehicleFilter: 0,
	groupFilter: 0,
};

const vehicleFilterReducer = (state = initialState, action) => {
	if (action.type === "vehicleFilter") {
		return { ...state, vehicleFilter: action.value };
	}

	if (action.type === "groupFilter") {
		return { ...state, groupFilter: action.value };
	}

	return state;
};

export default vehicleFilterReducer;

